// Generated by Melange

import * as JitsuReact from "@jitsu/jitsu-react";
import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__AdminDashboardPage from "./pages/AdminDashboardPage/AdminDashboardPage.js";
import * as Buhta_cabinet__AuthPage from "./pages/Auth/AuthPage.js";
import * as Buhta_cabinet__IdentFlowPage from "./pages/IdentFlowPage.js";
import * as Buhta_cabinet__OrgChoosePage from "./pages/Auth/OrgChoosePage.js";
import * as Buhta_cabinet__OrgDashboardPage from "./pages/OrgDashboardPage/OrgDashboardPage.js";
import * as Buhta_cabinet__ProfilePage from "./pages/Profile/ProfilePage.js";
import * as Buhta_cabinet__ReceiptETPPage from "./pages/ReceiptETPPage.js";
import * as Buhta_cabinet__ReceiptPage from "./pages/ReceiptPage.js";
import * as Buhta_cabinet__Route from "./Route.js";
import * as Buhta_cabinet__SignFlowPage from "./pages/SignFlow/SignFlowPage.js";
import * as Buhta_components__LoadingDiv from "../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_core__Auth from "../../../packages/core/lib/Auth.js";
import * as Buhta_core__Tenant from "../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as ReasonReactRouter from "reason-react/ReasonReactRouter.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function Home(Props) {
  let payload = Props.payload;
  const url = Buhta_cabinet__Route.useUrl(undefined);
  const route = React.useMemo((function () {
          return Buhta_cabinet__Route.ofUrl(url);
        }), [url]);
  const jitsu = JitsuReact.useJitsu();
  const match = Buhta_core__Auth.IdentityContext.useIdentity(undefined);
  const identity = match[0];
  const match$1 = Buhta_core__Tenant.useTenant(undefined);
  const dispatchTenantCtx = match$1[1];
  const tenant = match$1[0];
  React.useEffect((function () {
          if (typeof identity === "number") {
            if (!identity) {
              if (typeof route === "number") {
                ReasonReactRouter.push(Buhta_cabinet__Route.toString(/* Unauthorized */1));
              } else {
                switch (route.TAG | 0) {
                  case /* Auth */0 :
                  case /* Receipt */1 :
                  case /* EtpOrder */2 :
                  case /* IdentFlow */3 :
                  case /* SignFlow */4 :
                      break;
                  default:
                    ReasonReactRouter.push(Buhta_cabinet__Route.toString(/* Unauthorized */1));
                }
              }
            }
            
          } else {
            const identity$1 = identity._0;
            if (typeof route === "number") {
              Curry._1(dispatchTenantCtx, /* Reset */0);
            } else {
              switch (route.TAG | 0) {
                case /* Profile */5 :
                    Curry._1(dispatchTenantCtx, /* Reset */0);
                    break;
                case /* Org */6 :
                    const id = route._0;
                    const __x = identity$1.tenants;
                    const orgs = Belt__Belt_List.keepMap(__x, (function (tenant) {
                            const match = tenant.tenant;
                            if (match === undefined) {
                              return ;
                            }
                            const match$1 = match.info;
                            if (typeof match$1 === "string") {
                              return ;
                            }
                            if (match$1.NAME !== "Org") {
                              return ;
                            }
                            const org = match$1.VAL;
                            if (org.id === id) {
                              return org;
                            }
                            
                          }));
                    if (orgs) {
                      Curry._1(dispatchTenantCtx, {
                            TAG: /* OrgChanged */0,
                            _0: orgs.hd
                          });
                    }
                    break;
                case /* Admin */7 :
                    const adminRoute = route._0;
                    const __x$1 = identity$1.tenants;
                    const operators = Belt__Belt_List.keepMap(__x$1, (function (tenant) {
                            const match = tenant.tenant;
                            if (match === undefined) {
                              return ;
                            }
                            const match$1 = match.info;
                            if (typeof match$1 === "string" || match$1.NAME !== "Operator") {
                              return ;
                            } else {
                              return match$1.VAL;
                            }
                          }));
                    if (operators) {
                      const operator = operators.hd;
                      if (typeof adminRoute === "number" || !(adminRoute.TAG === /* Orgs */1 && typeof adminRoute._0 === "number")) {
                        Curry._1(dispatchTenantCtx, {
                              TAG: /* OperatorChanged */2,
                              _0: operator
                            });
                      } else {
                        Curry._1(dispatchTenantCtx, {
                              TAG: /* OperatorReset */1,
                              _0: operator
                            });
                      }
                    } else {
                      Buhta_cabinet__Route.navigateTo(/* Unauthorized */1);
                    }
                    break;
                default:
                  Curry._1(dispatchTenantCtx, /* Reset */0);
              }
            }
          }
          Curry._1(jitsu.analytics.page, undefined);
        }), [
        identity,
        route
      ]);
  if (typeof identity === "number") {
    if (identity) {
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {}),
                  className: "h-screen"
                });
    }
    if (typeof route === "number") {
      return "Access denied";
    }
    switch (route.TAG | 0) {
      case /* Auth */0 :
          return JsxRuntime.jsx(Buhta_cabinet__AuthPage.make, {
                      tab: route._0,
                      payload: payload
                    });
      case /* Receipt */1 :
          return JsxRuntime.jsx(Buhta_cabinet__ReceiptPage.make, {
                      kkm: route._0,
                      id: route._1
                    });
      case /* EtpOrder */2 :
          return JsxRuntime.jsx(Buhta_cabinet__ReceiptETPPage.make, {
                      etp: route._0,
                      id: route._1
                    });
      case /* IdentFlow */3 :
          return JsxRuntime.jsx(Buhta_cabinet__IdentFlowPage.make, {
                      code: route._0
                    });
      case /* SignFlow */4 :
          return JsxRuntime.jsx(Buhta_cabinet__SignFlowPage.make, {
                      code: route._0
                    });
      default:
        return "Access denied";
    }
  } else {
    const profile = identity._0;
    if (typeof route === "number") {
      switch (route) {
        case /* OrgChoose */0 :
            return JsxRuntime.jsx(Buhta_cabinet__OrgChoosePage.make, {
                        profile: profile
                      });
        case /* Unauthorized */1 :
            return "Unauthorized";
        case /* NotFound */2 :
            return "Not found";
        
      }
    } else {
      switch (route.TAG | 0) {
        case /* Auth */0 :
            return JsxRuntime.jsx(Buhta_cabinet__AuthPage.make, {
                        tab: route._0,
                        payload: payload
                      });
        case /* Receipt */1 :
            return JsxRuntime.jsx(Buhta_cabinet__ReceiptPage.make, {
                        kkm: route._0,
                        id: route._1
                      });
        case /* EtpOrder */2 :
            return JsxRuntime.jsx(Buhta_cabinet__ReceiptETPPage.make, {
                        etp: route._0,
                        id: route._1
                      });
        case /* IdentFlow */3 :
            return JsxRuntime.jsx(Buhta_cabinet__IdentFlowPage.make, {
                        code: route._0
                      });
        case /* SignFlow */4 :
            return JsxRuntime.jsx(Buhta_cabinet__SignFlowPage.make, {
                        code: route._0
                      });
        case /* Profile */5 :
            return JsxRuntime.jsx(Buhta_cabinet__ProfilePage.make, {
                        route: route._0,
                        profile: profile,
                        org: tenant.org
                      });
        case /* Org */6 :
            const match$2 = tenant.org.id;
            if (match$2 !== 0) {
              return JsxRuntime.jsx(Buhta_cabinet__OrgDashboardPage.make, {
                          org: tenant.org,
                          route: route._1
                        });
            } else {
              return null;
            }
        case /* Admin */7 :
            const match$3 = tenant.ctx;
            if (match$3) {
              return JsxRuntime.jsx(Buhta_cabinet__AdminDashboardPage.make, {
                          route: route._0
                        });
            } else {
              return "Unauthorized";
            }
        
      }
    }
  }
}

const make = Home;

export {
  make ,
}
/* @jitsu/jitsu-react Not a pure module */
